import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { AdminLogin } from './pages/AdminLogin';
import { CustomerDashboard } from './pages/CustomerDashboard';
import { BusinessDashboard } from './pages/BusinessDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Domains } from './pages/Domains';
import { SSLCertificates } from './pages/SSLCertificates';
import { Services } from './pages/Services';
import { ServerStatus } from './pages/ServerStatus';
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
function ProtectedAdminRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    adminUser,
    isAdminLoading
  } = useAuth();
  if (isAdminLoading) {
    return <div className="min-h-screen bg-slate-950 flex items-center justify-center" data-id="element-0">
        <div className="w-8 h-8 border-2 border-fox-500/30 border-t-fox-500 rounded-full animate-spin" data-id="element-1" />
      </div>;
  }
  if (!adminUser) {
    return <Navigate to="/backend" replace data-id="element-2" />;
  }
  return <>{children}</>;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-3">
      <Routes location={location} key={location.pathname} data-id="element-4">
        <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
        <Route path="/login" element={<Login data-id="element-8" />} data-id="element-7" />
        <Route path="/backend" element={<AdminLogin data-id="element-10" />} data-id="element-9" />
        <Route path="/cart" element={<Cart data-id="element-12" />} data-id="element-11" />
        <Route path="/checkout" element={<Checkout data-id="element-14" />} data-id="element-13" />
        <Route path="/domains" element={<Domains data-id="element-16" />} data-id="element-15" />
        <Route path="/ssl" element={<SSLCertificates data-id="element-18" />} data-id="element-17" />
        <Route path="/services/:category" element={<Services data-id="element-20" />} data-id="element-19" />
        <Route path="/status" element={<ServerStatus data-id="element-22" />} data-id="element-21" />
        <Route path="/dashboard/customer/*" element={<CustomerDashboard data-id="element-24" />} data-id="element-23" />
        <Route path="/dashboard/business/*" element={<BusinessDashboard data-id="element-26" />} data-id="element-25" />
        <Route path="/admin/*" element={<ProtectedAdminRoute data-id="element-28">
              <AdminDashboard data-id="element-29" />
            </ProtectedAdminRoute>} data-id="element-27" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <AppProvider data-id="element-30">
      <ThemeProvider data-id="element-31">
        <BrowserRouter data-id="element-32">
          <AuthProvider data-id="element-33">
            <AnimatedRoutes data-id="element-34" />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>;
}